import {
  SustainabilityFrameworkSection,
  ClimateVisionSection,
  SmartTechSection,
  ComplianceCertsSection,
  CircularThinkingSection,
  WorkforceDevelopmentSection,
  CommunityEngagementSection,
  SustainabilityMetricsSection,
  GovernanceSection,
  PartnershipsSection,
} from "@features/residential/components";

interface SustainabilityPageProps {
  hero: React.ReactNode;
  footer?: React.ReactNode;
}

export default function SustainabilityPage({ hero, footer }: SustainabilityPageProps) {
  return (
    <div className="w-full flex flex-col bg-white">
      {hero}
      <SustainabilityFrameworkSection />
      <ClimateVisionSection />
      <SmartTechSection />
      <ComplianceCertsSection />
      <CircularThinkingSection />
      <WorkforceDevelopmentSection />
      <CommunityEngagementSection />
      <SustainabilityMetricsSection />
      <GovernanceSection />
      <PartnershipsSection />
      {footer}
    </div>
  );
}
